export default [
  {
    path: "/nutrition",
    name: "nutritionMainpage",
    component: () => import(/* webpackChunkName: "nutrition" */ "@/views/nutrition/nutritionRoute.vue"),
    children: [
      {
        path: "",
        name: "nutritionMainpage",
        component: () => import(/* webpackChunkName: "nutrition" */ "@/views/nutrition/nutritionMainpage.vue"),
        meta: {
          hideBottomNavigation: true,
          navbarTitle: "Ernährungsplan",
        },
      },
      {
        path: "recipes",
        name: "nutritionRecipes",
        props: true,
        component: () => import(/* webpackChunkName: "nutrition" */ "@/views/nutrition/nutritionRecipes.vue"),
        meta: {
          hideBottomNavigation: true,
          navbarTitle: "Rezepte",
        },
      },
      {
        path: "shopping-list",
        name: "nutritionShoppingList",
        props: true,
        component: () => import(/* webpackChunkName: "nutrition" */ "@/views/nutrition/nutritionShoppinList.vue"),
        meta: {
          hideBottomNavigation: true,
          navbarTitle: "Shopping List",
        },
      },
    ],
  },
  // Good old habit :(
  {
    path: "/habits",
    name: "HabitHome",
    component: () => import(/* webpackChunkName: "habit" */ "@/views/habit/habitHome.vue"),
  },
]
